<template>
  <div>
    <form-section>
      <form-item prop="send_type">
        <radio-group v-model="model.send_type" inline>
          <radio
            :border="true"
            :label="0"
            :title="$t('CampaignForm_Schedule_ScheduleSelector_SendNow_Title')"
            :description="
              $t('CampaignForm_Schedule_ScheduleSelector_SendNow_Desc')
            "
            data-qa="schedule-send-now-option-radio"
          />
          <radio
            :border="true"
            :label="1"
            :title="
              $t('CampaignForm_Schedule_ScheduleSelector_SendLater_Title')
            "
            :description="
              $t('CampaignForm_Schedule_ScheduleSelector_SendLater_Desc')
            "
            data-qa="schedule-send-later-option-radio"
          />
          <radio
            :border="true"
            :label="2"
            :title="$t('CampaignForm_Schedule_ScheduleSelector_Repeat_Title')"
            :description="
              $t('CampaignForm_Schedule_ScheduleSelector_Repeat_Desc')
            "
            data-qa="schedule-repeat-option-radio"
          />
        </radio-group>
      </form-item>
      <div v-if="model.send_type" class="separator"></div>
      <send-later-component v-if="model.send_type === 1" :model="model" />
      <repeat-component v-if="model.send_type === 2" :model="model" />
    </form-section>
    <offline-users-component v-if="showOfflineUsers" :model="model" />
    <persist-content-component
      v-if="model.inbox && !isWorkflowCampaign"
      :model="model"
    />
    <campaign-throttling-component
      v-if="
        !isWorkflowCampaign &&
          (!isEditing || isDraft || isPast || isFuture || isLive)
      "
      :is-throttling-available="isThrottlingAvailable"
      :readonly="isLive"
      :model="model"
    ></campaign-throttling-component>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
import SendLaterComponent from '@/modules/campaign-manage/components/schedule/SendLaterComponent'
import OfflineUsersComponent from '@/modules/campaign-manage/components/schedule/OfflineUsersComponent'
import RepeatComponent from '@/modules/campaign-manage/components/schedule/RepeatComponent'
import PersistContentComponent from '@/modules/campaign-manage/components/schedule/PersistContentComponent'
import CampaignThrottlingComponent from '@/modules/campaign-manage/components/schedule/CampaignThrottlingComponent'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'ScheduleSelector',
  components: {
    PersistContentComponent,
    OfflineUsersComponent,
    SendLaterComponent,
    RepeatComponent,
    Radio,
    RadioGroup,
    FormItem,
    FormSection,
    CampaignThrottlingComponent
  },
  props: {
    model: {
      type: Object
    }
  },
  computed: {
    isStandardCampaign() {
      return this.model.type === campaignTypeEnum.TYPE_NOTIFICATION
    },
    isWorkflowCampaign() {
      return this.model.type === campaignTypeEnum.TYPE_WORKFLOW
    },
    isEditing() {
      return this.model.id !== null
    },
    isThrottlingAvailable() {
      let isAvailable =
        $hasFeature('featureCampaignThrottling') &&
        [0, 1].includes(this.model.send_type)
      let isOneChannelSelected = false
      if (isAvailable) {
        let possibleChannels = [
          'web_push',
          'sms',
          'email',
          'ios_push',
          'android_push',
          'inbox',
          'webhook'
        ]
        possibleChannels.forEach(channel => {
          isOneChannelSelected = isOneChannelSelected || !!this.model[channel]
        })
      }

      return isAvailable && isOneChannelSelected
    },
    isDraft() {
      return (
        this.model.hasOwnProperty('status_canonical') &&
        this.model.status_canonical === 'draft'
      )
    },
    isPast() {
      return (
        this.model.hasOwnProperty('status_canonical') &&
        this.model.status_canonical === 'past'
      )
    },
    isFuture() {
      return (
        this.model.hasOwnProperty('status_canonical') &&
        this.model.status_canonical === 'scheduled'
      )
    },
    isLive() {
      return (
        this.model.hasOwnProperty('status_canonical') &&
        this.model.status_canonical === 'live'
      )
    },
    showOfflineUsers() {
      if (this.isStandardCampaign) {
        return (
          this.model.ios_push ||
          this.model.android_push ||
          this.model.web_push ||
          this.model.inapp_ios ||
          this.model.inapp_android ||
          this.model.onsite
        )
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
>>> .el-radio {
  height: unset !important;
  min-height: 80px !important;
  max-height: 120px !important;
  white-space: unset;
}

>>> .title {
  font-weight: 600;
  line-height: 22px;
  color: #5c6374;
}
.separator {
  margin: 24px -20px;
  border-top: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/ScheduleSelector.vue